import firebase, { getFirestore } from "datastore/database";
import store from "datastore/store";
import { collection, onSnapshot } from "firebase/firestore";

const getCollectionUrl = (uid) => `events/business/${uid}`;

export function observe(businessUid) {
  store.dispatch({ type: "ADD_EVENTS_LOADING" });
  const collectionRef = collection(
    getFirestore(),
    `events/business/${businessUid}`
  );
  return onSnapshot(collectionRef, (snapshot) => {
    store.dispatch({ type: "SET_EVENTS_LOADING", data: false });
    const updates = {
      added: [],
      modified: [],
      removed: [],
    };
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        updates.added.push({ uid: change.doc.id, ...change.doc.data() });
      }
      if (change.type === "modified") {
        updates.modified.push({ uid: change.doc.id, ...change.doc.data() });
      }
      if (change.type === "removed") {
        updates.removed.push({ uid: change.doc.id, ...change.doc.data() });
      }
    });
    if (updates.added.length > 0) {
      store.dispatch({ type: "ADD_EVENTS", data: updates.added });
    }
    if (updates.modified.length > 0) {
      store.dispatch({
        type: "UPDATE_EVENTS",
        data: updates.modified,
      });
    }
    if (updates.removed.length > 0) {
      store.dispatch({
        type: "DELETE_EVENTS",
        data: updates.removed,
      });
    }
  });
}

export async function update(businessUid, uid, data) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .update(data, { merge: true });
}
export async function remove(businessUid, uid) {
  return firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(uid)
    .delete();
}
export function add(businessUid, data) {
  const doc = firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc();
  doc.set(data);
  return { uid: doc.id, ...data };
}
export const getBusinessByUid = async (businessUid) => {
  const docSnap = await firebase
    .firestore()
    .collection("businesses")
    .doc(businessUid)
    .get();
  return { uid: docSnap.id, ...docSnap.data() };
};
export const getEventByUid = async (businessUid, eventUid) => {
  const docSnap = await firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .doc(eventUid)
    .get();
  return { uid: docSnap.id, ...docSnap.data() };
};

export const getEventBannerImage = async (businessUid, eventUid) => {
  let storageRef = firebase
    .storage()
    .ref(`event-banner-images/${businessUid}/${eventUid}`);
  const images = await storageRef?.listAll();
  const imgUrls = await Promise.all(
    images?.items?.map((imageRef) => imageRef.getDownloadURL())
  );
  return imgUrls;
  /* images?.items?.forEach((imageRef) => {
    
  }); */
};
export const getEventReservations = async (businessUid, eventUid) => {
  const collectionRef = firebase
    .firestore()
    .collection(`reservations/business/${businessUid}`)
    .where("eventUid", "==", eventUid);
  const snapshot = await collectionRef.get();
  return snapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));
};

export const getEventSeries = async (businessUid, eventUid) => {
  const collectionRef = firebase
    .firestore()
    .collection(getCollectionUrl(businessUid))
    .where("eventUid", "==", eventUid);
  const snapshot = await collectionRef.get();
  return snapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));
}